import dayjs from 'dayjs';

/**
 * Keeps a `weekStart` anchor aligned with an arbitrary `date`, by shifting it in whole 7-day
 * steps until `date` falls inside `[weekStart, weekStart + 6 days]` (UNIVAPLAT-2360 follow-up).
 *
 * Weeks are exactly 7 days long — the same assumption {@see PatientWeeklyDetailPage}'s own
 * navigateToPrevWeek()/navigateToNextWeek() make when shifting `dateStart` — so shifting an
 * already-correctly-aligned anchor by whole weeks keeps it aligned with the true care-programme
 * week boundary, without this (purely client-side) code needing to know that boundary from
 * scratch. When `weekStart` is null (no anchor was ever supplied, e.g. a direct/bookmarked URL
 * with no weekStart param) there is nothing to align, so it is returned as-is: only a real
 * backend "week containing this date" lookup could resolve that case correctly.
 */
export function alignWeekStartToDate(date: string, weekStart: string | null): string | null {
    if (!weekStart) {
        return null;
    }

    const d = dayjs(date);
    let ws = dayjs(weekStart);

    while (d.isBefore(ws, 'day')) {
        ws = ws.subtract(7, 'day');
    }
    while (d.isAfter(ws.add(6, 'day'), 'day')) {
        ws = ws.add(7, 'day');
    }

    return ws.format('YYYY-MM-DD');
}
